import { FC, memo } from 'react'
import Info from '../../../assets/icons/info.svg'
import { useAppDispatch } from '../../hooks/redux'
import { setCustomerInfoDialog } from '../../redux/reducers/app'
import { performHaptics } from '../../utils/performHaptics'
import BarButtonWithIcon from '../UI/buttons/BarButtonWithIcon'

interface InfoButtonProps {
    code: string
    customer: {
        name: string
        phone?: string
        address?: string
    }
    textColor: string
    orderKey: string
}

const InfoButton: FC<InfoButtonProps> = ({ code, customer, textColor, orderKey }) => {
    const dispatch = useAppDispatch()

    const handlePress = () => {
        performHaptics()

        dispatch(
            setCustomerInfoDialog({
                orderCode: code,
                customerName: customer.name,
                customerPhone: customer.phone,
                customerAddress: customer.address,
                orderKey,
            })
        )
    }

    return (
        <BarButtonWithIcon color={textColor} fontSize={17} onPress={handlePress} Icon={Info}>
            {code}
        </BarButtonWithIcon>
    )
}

export default memo(InfoButton)
